// @flow
import React from 'react';
import { useFormikContext } from 'formik';

import { BasicButton } from '../presentational/buttons/BasicButton';
import { If } from '../presentational/If';

import {
  canAddMultipleRowsForMetricForEstimateCC,
  getConfiguredMetricRowsFromFormikValuesForEstimateCC,
  getIfAnyRowIsBeingEditedAnyWhereInAnyMetricForEstimateCC,
  getMetricLabelFromMetricNameForEstimateCC,
  getNewDimensionsRowWithDefaultsForEstimateCC,
} from './utils';

export const CommittedCapacityAddMetricRowContainerForEstimateCC = ({
  metricRow,
  dimensionsArrayHelpers,
}) => {
  const { values: formikValues } = useFormikContext();
  const configuredMetrics = getConfiguredMetricRowsFromFormikValuesForEstimateCC(formikValues);
  const shouldAddMetricBeDisabled =
    getIfAnyRowIsBeingEditedAnyWhereInAnyMetricForEstimateCC(configuredMetrics);
  const metricName = metricRow.metricName;

  return (
    <If test={metricName != null && canAddMultipleRowsForMetricForEstimateCC(metricName)}>
      <BasicButton
        color="blue"
        disabled={shouldAddMetricBeDisabled}
        onClick={() => {
          const newRow = getNewDimensionsRowWithDefaultsForEstimateCC(metricName);
          return dimensionsArrayHelpers.push(newRow);
        }}
        text={`+ Add ${getMetricLabelFromMetricNameForEstimateCC(metricName)}`}
      />
    </If>
  );
};
